import { param } from 'jquery'
import * as factory from '../../../iawp/src/js/factory'
const i18n = await import('./translations/' + document.querySelector('html').getAttribute('lang'))
const pll = i18n.default

new factory.IAInit()

if (!!document.querySelector('.ia-block-navigation__toggle button[aria-controls="mobileNavigation"]')) {
    document.querySelectorAll('.ia-block-navigation__toggle button[aria-controls="mobileNavigation"]').forEach((toggle) => {
        toggle.addEventListener('click', (e) => {
            let isOpen = toggle.getAttribute('aria-expanded') === 'true'
            let content = toggle.getAttribute('aria-controls') ? document.getElementById(toggle.getAttribute('aria-controls')) : toggle.nextElementSibling
            if (isOpen) {
                content.classList.remove('is-open')
                toggle.setAttribute('aria-expanded', false)
                toggle.querySelector('i').classList.add('fa-bars')
                toggle.querySelector('i').classList.remove('fa-times')
            } else {
                content.classList.add('is-open')
                toggle.setAttribute('aria-expanded', true)
                toggle.querySelector('i').classList.add('fa-times')
                toggle.querySelector('i').classList.remove('fa-bars')
            }
        })
    })
}

if (!!document.querySelector('.section-mobile-navigation')) {

    document.querySelectorAll('.section-mobile-navigation .menu-item-has-children > .sub-menu').forEach(submenu => {
        if (!submenu.parentElement.classList.contains('ia-current') && !submenu.querySelector('.current-menu-item'))
            submenu.style.display = 'none'
        
    })

    document.querySelectorAll('.open-menu-btn').forEach(button => {
        const subMenu = button.closest('li').querySelector('.sub-menu');
        const icon = button.querySelector('i');

        if (subMenu) {
            // Vérifie si le sous-menu est visible et ajuste l'icône en conséquence
            const isVisible = getComputedStyle(subMenu).display === 'none';
            icon.classList.toggle('fa-angle-down', isVisible);
            icon.classList.toggle('fa-angle-up', !isVisible);
        }
    });

    document.querySelectorAll('.section-mobile-navigation .menu-item-has-children > a > .open-menu-btn').forEach(openMenuBtn => {
        let icon = openMenuBtn.querySelector('i')
        openMenuBtn.addEventListener('click', (e) => {
            e.preventDefault()
            if (Array.from(icon.classList).indexOf('fa-angle-down') !== -1) {
                icon.classList.remove('fa-angle-down')
                icon.classList.add('fa-angle-up')
            } else {
                icon.classList.remove('fa-angle-up')
                icon.classList.add('fa-angle-down')
            }

            factory.$(openMenuBtn.parentElement.nextElementSibling).slideToggle()
        })
    })
}

if (!!document.querySelector('.ia-block-dropdown')) {
    document.querySelectorAll('.ia-block-dropdown').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-dropdown-toggle'), 
            dropdown.querySelector('.ia-block-dropdown-content') 
        )
    })
}

if (!!document.querySelector('body.home .swiper-container')) {
    document.querySelectorAll('body.home .swiper-container').forEach(el => {
        let s = new factory.IASwiper(el, {
            autoplay: false,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev')
            },
            a11y: {
                prevSlideMessage: pll.prevSlideMessage,
                nextSlideMessage: pll.nextSlideMessage,
                firstSlideMessage: pll.firstSlideMessage,
                lastSlideMessage: pll.lastSlideMessage,
                paginationBulletMessage: pll.paginationBulletMessage
            }
        })

        el.querySelector('.ia-block-slider__button--pause').addEventListener('click', function() {
            s.instance.autoplay.pause()
            s.instance.el.querySelector('.ia-block-slider__button--pause').classList.add('hidden')
            s.instance.el.querySelector('.ia-block-slider__button--play').classList.remove('hidden')
            console.log(s.instance.autoplay)

        })

        el.querySelector('.ia-block-slider__button--play').addEventListener('click', function() {
            s.instance.autoplay.run()
            s.instance.el.querySelector('.ia-block-slider__button--pause').classList.remove('hidden')
            s.instance.el.querySelector('.ia-block-slider__button--play').classList.add('hidden')
            console.log(s.instance.autoplay)
        })
    })
}

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}

if(!!document.querySelectorAll('.ia-block-list-faq')){
    document.querySelectorAll('.ia-block-list-faq__item').forEach((dropdown)=>{
        new factory.IADropdown(
            dropdown.querySelector('.ia-block-list-faq__item__dropdown'), 
            dropdown.querySelector('.dropdown-content') 
        )
    })
}


// Contacts Map
if (!!document.querySelector('.ia-block-contacts-map')) {
    if (!!document.querySelector('.ia-block-contacts-map__regions-link')) {
        document.querySelectorAll('.ia-block-contacts-map__regions-link').forEach(link => {
            link.addEventListener('click', (e) => {
                hideAllRegions(link.getAttribute('data-region'))

                let isExpanded = false
                let target = document.getElementById(link.getAttribute('aria-controls'))
                link.setAttribute('aria-expanded', !isExpanded)
                if (!isExpanded) {
                    link.setAttribute('hidden', 'hidden')
                    target.removeAttribute('hidden')
                    document.querySelectorAll('.svg-map-region[data-region="' + link.getAttribute('data-region') + '"]').forEach(region => region.classList.add('active'))
                } else {
                    link.removeAttribute('hidden')
                    target.setAttribute('hidden', 'hidden')
                }
            })
        })
    }

    if (!!document.querySelector('.svg-map-region')) {
        document.querySelectorAll('.svg-map-region').forEach(region => {
            region.addEventListener('click', (e) => {
                if( region.getAttribute('data-sous-region')){
                    let target = document.querySelector('.ia-block-contacts-map__regions-link[data-region="' + region.getAttribute('data-region') + '"]')

                    document.querySelector('.ia-block-contacts-map__subregions-link[data-region="' + region.getAttribute('data-region') + '"][data-sous-region="' + region.getAttribute('data-sous-region') + '"]').dispatchEvent(new Event('click'))
                    if (target.getAttribute('aria-expanded') === 'false') {
                        target.dispatchEvent(new Event('click'))
                    }
                } else {
                    let target = document.querySelector('.ia-block-contacts-map__regions-link[data-region="' + region.getAttribute('data-region') + '"]')
                    target.dispatchEvent(new Event('click'))
                }
            })
        })
    }

    if (!!document.querySelector('.ia-block-contacts-map__regions-title')) {
        document.querySelectorAll('.ia-block-contacts-map__regions-title').forEach(link => {
            link.addEventListener('click', (e) => {
                let parent = link.closest('.ia-block-contacts-map__regions-content')
                let target = document.querySelector('.ia-block-contacts-map__regions-link[aria-controls="' + parent.getAttribute('id') + '"]')
                target.dispatchEvent(new Event('click'))
                if (target.getAttribute('aria-expanded') === 'true') {
                    hideAllRegions()
                }
            })
        })
    }

    if (!!document.querySelector('.ia-block-contacts-map__subregions-link')) {
        document.querySelectorAll('.ia-block-contacts-map__subregions-link').forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault()
                let subregion = link.getAttribute('data-sous-region')
                document.querySelectorAll('.ia-block-contacts-map__contacts-item[data-sous-region]').forEach(target => {
                    target.setAttribute('hidden', 'hidden')
                })

                let targets = document.querySelectorAll('.ia-block-contacts-map__contacts-item[data-sous-region="' + subregion + '"]')
                targets.forEach(target => {
                    if (target.getAttribute('hidden') === 'hidden') {
                        target.removeAttribute('hidden')
                    } else {
                        target.setAttribute('hidden', 'hidden')
                    }
                })

                document.querySelectorAll('.svg-map-region').forEach(region => {
                    if (region.getAttribute('data-sous-region') === subregion) {
                        region.classList.add('sub-active')
                    } else {
                        region.classList.remove('sub-active')
                    }
                })
            })
        })
    }

    function hideAllRegions(exception) {
        document.querySelectorAll('.svg-map-region').forEach(region => {
            if (exception && region.getAttribute('data-region') === exception) {
                return
            }
            if (exception && region.getAttribute('data-sous-region') === exception) {
                region.classList.add('sub-active')
                return
            }

            region.classList.remove('active', 'sub-active')
        })

        document.querySelectorAll('.ia-block-contacts-map__regions-link').forEach(region => {
            if (exception && region.getAttribute('data-region') === exception) {
                return
            }
            region.setAttribute('aria-expanded', false)
            region.removeAttribute('hidden')
            document.getElementById(region.getAttribute('aria-controls')).setAttribute('hidden', 'hidden')
        })
    }
}

if (!!document.querySelector('.ia-block-searchbar-toggle') && document.querySelector('.ia-block-searchbar#iaSearchForm')) {
    document.querySelectorAll('[aria-controls="iaSearchForm"]').forEach(toggle => {
        toggle.addEventListener('click', () => {
            let menuExpanded = document.querySelector('#mobileNavigation').getAttribute('aria-expanded') === 'true'
            let isExpanded = toggle.getAttribute('aria-expanded') === 'true'
            toggle.setAttribute('aria-expanded', !isExpanded)
            if (isExpanded) {
                document.querySelector('.ia-block-searchbar#iaSearchForm').setAttribute('hidden', 'hidden')
            } else {
                if (menuExpanded) {
                    document.querySelector('[aria-controls="mobileNavigation"]').dispatchEvent(new Event('click'))
                }
                document.querySelector('.ia-block-searchbar#iaSearchForm').removeAttribute('hidden')
            }
        })
    })
}

if (!!document.querySelector('.ia-block-list-posts')) {
    document.querySelectorAll('.ia-block-list-posts').forEach(block => {
        let form = block.querySelector('.ia-block-list-posts__sidebar')
        let contents = block.querySelector('.ia-block-list-posts__content')
        let tags = [];

        form.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('change', (e) => {
            e.preventDefault();
            form.querySelector('input[name="paged"]').value = 1
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })
        }))        

        factory.$(block).on('click', '.wp-block-pagination a.page-numbers', function(e) {
            e.preventDefault();
            let page = factory.$(this).text()

            if (page == '>') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) + 1
            } else if (page == '<') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) - 1
            }
            
            factory.$(form).find('input[name="paged"]').val(page)
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })

        })
    })
}

if (!!document.querySelector('.ia-block-list-events')) {
    document.querySelectorAll('.ia-block-list-events').forEach(block => {
        let form = block.querySelector('.ia-block-list-events__sidebar')
        let contents = block.querySelector('.ia-block-list-events__content')
        let tags = []

        form.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('change', (e) => {
            e.preventDefault();
            form.querySelector('input[name="paged"]').value = 1
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })
        }))

        factory.$(block).on('click', '.wp-block-pagination a.page-numbers', function(e) {
            e.preventDefault();
            let page = factory.$(this).text()

            if (page == '>') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) + 1
            } else if (page == '<') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) - 1
            }

            factory.$(form).find('input[name="paged"]').val(page)
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })

        })
    })
}

if (!!document.querySelector('.ia-block-list-publications')) {
    document.querySelectorAll('.ia-block-list-publications').forEach(block => {
        let form = block.querySelector('.ia-block-list-publications__sidebar')
        let contents = block.querySelector('.ia-block-list-publications__content')
        let tags = []

        form.querySelectorAll('input[type="checkbox"]').forEach(input => input.addEventListener('change', (e) => {
            e.preventDefault();
            form.querySelector('input[name="paged"]').value = 1
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })
        }))

        factory.$(block).on('click', '.wp-block-pagination a.page-numbers', function(e) {
            e.preventDefault();
            let page = factory.$(this).text()

            if (page == '>') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) + 1
            } else if (page == '<') {
                page = parseInt(factory.$(form).find('input[name="paged"]').val()) - 1
            }

            factory.$(form).find('input[name="paged"]').val(page)
            factory.$.ajax({
                method: 'POST',
                url: ajaxurl,
                data: factory.$(form).serialize(),
                success: function(response) {
                    console.log(response)
                    response = JSON.parse(response)
                    console.log(response)

                    factory.$(contents).html(factory.$(response.listing))
                    factory.$(contents).append(factory.$(response.pagination))
                }
            })

        })
    })
}

if (!!document.querySelector('.ia-block-timeline')) {
    document.querySelectorAll('.ia-block-timeline').forEach(block => {
        let swiperNav = new Swiper(block.querySelector('.ia-block-timeline__navigation-slider'), {
            watchSlidesProgress: true,
            freeMode: {
                enabled: false,
                sticky: true
            },
            slidesPerView: 1,
            // Responsive breakpoints
            breakpoints: {
                // when window width is >= 320px
                320: {
                slidesPerView: 2,
                },
                // when window width is >= 480px
                480: {
                slidesPerView: 3,
                },
                // when window width is >= 640px
                640: {
                slidesPerView: 4,
                }
            }
        });

        let swiperContent = new Swiper(block.querySelector('.ia-block-timeline__slider'), {
            slidesPerView: 1,
            autoHeight: true,
            navigation: {
                nextEl: block.querySelector('.ia-block-timeline__navigation-slider .swiper-button-next'),
                prevEl: block.querySelector('.ia-block-timeline__navigation-slider .swiper-button-prev')
            },
            thumbs: {
                swiper: swiperNav
            },
            a11y: {
                prevSlideMessage: pll.prevSlideMessage,
                nextSlideMessage: pll.nextSlideMessage,
                firstSlideMessage: pll.firstSlideMessage,
                lastSlideMessage: pll.lastSlideMessage,
                paginationBulletMessage: pll.paginationBulletMessage
            }
        })
    })
}

if (!!document.querySelector('.ia-block-page-toolbar')) {
    document.querySelectorAll('.ia-block-page-toolbar__button').forEach(button => {
        button.addEventListener('click', () => {
            if (button.getAttribute('data-action') && button.getAttribute('data-action') === 'print') {
                // Print page
                window.print()
            }

            if (button.getAttribute('data-endpoint') && button.getAttribute('data-endpoint') !== '') {
                let endpoint = button.getAttribute('data-endpoint')
                let params = JSON.parse(button.getAttribute('data-params'))
                let url = endpoint + '?' + Object.keys(params).map(key => key + '=' + encodeURIComponent(params[key])).join('&')
                window.open(
                    url,
                    'sharer',
                    'toolbar=0,status=0,resizable=1,width=600,height=600'
                )
            }
        })
    })
}

if (!!document.querySelector('.ia-block-back-to-top__button')) {
    let backToTop = document.querySelector('.ia-block-back-to-top .ia-block-back-to-top__button')

    backToTop.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    })
}

const params = new URLSearchParams(window.location.search)
if (params.has("s")) {
    const searchTerm = params.get("s")

    if (searchTerm) {
        document.querySelectorAll('.search-result').forEach(element => {
            highlightText(element, searchTerm)
        })
    }
}

function highlightText(element, searchTerm) {
    // Fonction pour enlever les accents
    function removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    const normalizedSearchTerm = removeAccents(searchTerm);
    const regex = new RegExp(`(${normalizedSearchTerm})`, "gi");
    document.querySelector('.searchform-results__field').value = searchTerm

    function processNode(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.nodeValue;
            const normalizedText = removeAccents(text);

            if (text.trim() !== "") {
                let replacedText = "";
                let lastIndex = 0;
                normalizedText.replace(regex, (match, p1, offset) => {
                    replacedText += text.substring(lastIndex, offset) +
                        `<mark class="search-result-item">${text.substring(offset, offset + p1.length)}</mark>`;
                    lastIndex = offset + p1.length;
                    return match;
                });
                replacedText += text.substring(lastIndex);

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = replacedText;
                while (tempDiv.firstChild) {
                    node.parentNode.insertBefore(tempDiv.firstChild, node);
                }
                node.parentNode.removeChild(node);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SCRIPT" && node.tagName !== "STYLE") {
            Array.from(node.childNodes).forEach(child => processNode(child));
        }
    }

    processNode(element);
}
